import { defineFeatureFlag } from './state';

export const aiChatConversationDownloadFlag = defineFeatureFlag('ai-chat-conversation-download', {
	default: false,
	title: 'AI Chat Conversation Download',
	description: 'Adds a debug control for downloading the complete raw AI chat conversation',
});

export const customSpacesFlag = defineFeatureFlag('custom-spaces', {
	default: false,
	title: 'Custom Spaces',
	description: 'Exposes spaces as a concept: the space navigation entries and creating, editing and deleting spaces',
});

export const extensionsFlag = defineFeatureFlag('extensions', {
	default: false,
	title: 'Extensions',
	description: 'Enables extension catalogs and data connectors in Studio',
});

export const gridLayoutBlockDebugFlag = defineFeatureFlag('grid-layout-block-debug', {
	default: false,
	title: 'Grid Layout Block Debug',
	description: 'Enables the grid layout debugger in the block editor',
});

export const unsavedChangesWarningFlag = defineFeatureFlag('unsaved-changes-warning', {
	default: true,
	title: 'Unsaved Changes Warning',
	description: 'Warns before reloading or closing the tab with unsaved changes',
});

export const virtualizeColumnAutosizeOnScrollFlag = defineFeatureFlag('virtualize-column-autosize-on-scroll', {
	default: false,
	title: 'Virtualized Table Autosize On Scroll',
	description: 'Remeasures auto-sized virtualized listing columns while rows recycle during scroll',
});
